import {
  getUpdatedDesignData,
  getColorValue,
  getOpacityValue,
  getStyleFill,
  getStyleOpacity,
  getUpdatedStyleData,
} from './advancedColorPickerUtils';
import { initialDesignItemBackground } from './constants';
import _ from 'lodash';
import { array } from '#packages/util';
import type { CompRef } from 'types/documentServices';
import type { EditorAPI } from '#packages/editorAPI';
import type { ColorPickerValues } from './advancedColorPickerUtils';

export const getBackgroundDesignValuesForColorpicker = (
  editorAPI: EditorAPI,
  compRef?: CompRef,
) => {
  const backdroundData =
    editorAPI.components.design.get(compRef)?.background ||
    initialDesignItemBackground;
  let color = getColorValue(backdroundData);
  if (typeof color === 'string') {
    color = color.replace(/[\{\}]/g, '');
  }

  return {
    color,
    alpha: getOpacityValue(backdroundData),
  };
};

export const updateComponentDesign = (
  editorAPI: EditorAPI,
  selectedComponent: CompRef,
  newValue: ColorPickerValues,
) => {
  const oldBackgroundData =
    editorAPI.components.design.get(selectedComponent)?.background;
  const newData = getUpdatedDesignData(
    oldBackgroundData || initialDesignItemBackground,
    newValue,
  );
  editorAPI.components.design.update(
    selectedComponent,
    {
      type: 'MediaContainerWithDividers',
      background: newData,
    },
    true,
  );
  const oldBgValue = oldBackgroundData?.colorLayers?.[0]?.fill;
  const newBgValue = newData?.colorLayers?.[0]?.fill;
  const hasBgChanged = !_.isEqual(oldBgValue, newBgValue);
  const valueChanged = hasBgChanged
    ? { param: 'bg', value: newValue.color }
    : { param: 'alpha-bg', value: newValue.alpha };

  return valueChanged;
};

export const getContainerStyleValuesForColorPicker = (
  editorAPI: EditorAPI,
  compRef?: CompRef,
) => {
  const actualCompRef = Array.isArray(compRef) ? compRef[0] : compRef;
  const compStyle = editorAPI.components.style.get(actualCompRef)?.style;

  return {
    color: getStyleFill(compStyle),
    alpha: Number(getStyleOpacity(compStyle)),
  };
};

export const updateStyle = (
  editorAPI: EditorAPI,
  selectedComponent: CompRef[] | CompRef,
  newValue: ColorPickerValues,
) => {
  array.asArray(selectedComponent).forEach((compRef) => {
    updateStyleItem(editorAPI, compRef, newValue);
  });
};

const updateStyleItem = (
  editorAPI: EditorAPI,
  selectedComponent: CompRef,
  newValue: ColorPickerValues,
) => {
  const oldStyle = editorAPI.components.style.get(selectedComponent);
  const newStyle = getUpdatedStyleData(oldStyle.style, newValue);
  editorAPI.components.style.update(
    selectedComponent,
    {
      ...oldStyle,
      style: newStyle,
    },
    true,
  );
};
